import { Component, OnInit, ChangeDetectionStrategy, Inject, SecurityContext, OnDestroy } from '@angular/core';
import { BehaviorSubject, filter, first, Observable, Subject, takeUntil } from 'rxjs';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { LgvAPIService, LgvAuth0Guard, LgvClientService, LgvUserService, NotificationService } from '../../core/core.module';
import { GlossaryDefinition } from '../../core/services/lgv-glossary.service';
import { DomSanitizer } from '@angular/platform-browser';
import { LgvAuthMgrService } from '../../core/services/lgv-auth-mgr.service';
import { LgvCompanyService } from '../../core/services/lgv-company.service';

@Component({
    selector: 'email-popup',
    templateUrl: 'email-popup.component.html',
})

export class EmailPopup implements OnInit, OnDestroy {

    Message: string;

    _SubmissionStatus: string = 'NA';
    SubmissionStatus$ = new BehaviorSubject(this._SubmissionStatus);
    onDestroy$ = new Subject();

    agentNameDisplay$ = new BehaviorSubject("your Loan Advisor");

    constructor(
        public dialogRef: MatDialogRef<EmailPopup>,
        private router: Router,
        private LgvClientSvc: LgvClientService,
        private lgvCompanySvc: LgvCompanyService,
        private lgvUserSvc: LgvUserService,
        private LgvAuthMgr: LgvAuthMgrService,
        private NotificationSvc: NotificationService,
        private sanitizer: DomSanitizer,
        @Inject(MAT_DIALOG_DATA) public data: any) {
        //console.log('EmailPopup: data:');
        //console.log(data);

        this.InitMessage(data.type);
        this.Message = data.message ?? this.Message;

        this.LgvClientSvc.PostPageClick(`Send Email - ${data.type}`).pipe(first()).subscribe();

    }

    ngOnInit(): void {
        this.lgvUserSvc.AgentDTO$.pipe(filter(f=> !!f), takeUntil(this.onDestroy$)).subscribe(x=>{
            this.agentNameDisplay$.next(`${x.agentInfo?.firstName} ${x.agentInfo?.lastName}`)
        });
    }

    ngOnDestroy() {
        this.onDestroy$.next(true);
        this.onDestroy$.complete();
    }

    onNoClick(): void {
        this.dialogRef.close();
    }

    OnSendEmail() {

        if (!this.LgvAuthMgr.IsClient) {
            this.NotificationSvc.warn("Messages are not sent for Client Impersonation");
            return;
        }

        this.SubmissionStatus$.next("Sending");
        let cleanMsg = this.sanitizer.sanitize(SecurityContext.HTML, this.Message);

        this.LgvClientSvc.PostClientMessageForType(this.data.type, cleanMsg).pipe(takeUntil(this.onDestroy$)).subscribe(x => {

            if (x === null) {
                //this.Notifications.success('Request was submitted.');
                this.SubmissionStatus$.next('Success');
                //this.dialogRef.close();
            }
        },
            err => this.SubmissionStatus$.next('Error')
        );

    }

    InitMessage(msgType: string) {
        switch (msgType) {
            case 'Cash Out': this.Message = 'I am interested in exploring my cash out options.'; break;
            case 'Refinancing': this.Message = 'I am interested in hearing more about my refinance options.'; break;
            case 'CMA Request': this.Message = 'I would like a Comparative Market Analysis performed.'; break;
            case 'RequestInfoOnBridgeLoan': this.Message = 'I would like more information about your Bridge Loan.'; break;
            case 'RequestInfoOnRealEstateInvestment': this.Message = 'I would like more information about Investing in Real Estate.'; break;
            case 'RequestInfoOnSellYourHome': this.Message = 'I would like more information about your Sell Your Home and Cash Out.'; break;
            case 'Equity Gained': this.Message = 'I am interested in exploring my equity gained options.'; break;
            case 'Loan Application': this.Message = 'I am interested in applying for a loan.'; break;
            case 'Rate Quote': this.Message = 'I am interested in getting a rate quote.'; break;
            case 'Blank': this.Message = ''; break;
            default: this.Message = `I have a question about the HomeDashboard site.`; break;
        }
    }

    onReturnToClientHome() {
        this.LgvClientSvc.navigateToHomePage();
    }
}
